import { FilterOption } from '@britishcouncil/react-admin';
import { useMemo } from 'react';

import { useGetCountriesQuery } from 'store/countries/countriesApi';

export function useCountriesOptions(regions: number[] | undefined): FilterOption<number>[] {
  const { data } = useGetCountriesQuery(regions);

  const countries = useMemo(
    () =>
      data?.map((country) => ({
        text: country.name,
        value: country.id,
      })) ?? [],
    [data]
  );

  return countries;
}
